module.exports = __webpack_public_path__ + "static/media/beQI.4570e15c.png";